import { render } from "./OrdersList.vue?vue&type=template&id=694c9001&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=694c9001&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694c9001"]])

export default __exports__